import { backgroundStyles, fontStyles } from 'styles/theme';
import FlexContainer from 'components/common/FlexContainer';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const Container = styled(FlexContainer)({
  padding: '20px 26px',
  gap: 4,
  borderRadius: '6px',
  alignSelf: 'stretch',
  flex: 1,
  backgroundColor: backgroundStyles.colors.quaternary,
  [mobileMediaQuery]: {
    padding: 16,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
  },
});

export const CreditPointsContainer = styled(FlexContainer)({
  gap: 4,
  alignItems: 'flex-end',
  [mobileMediaQuery]: {
    alignItems: 'flex-start',
  },
});

export const CreditPointsNumber = styled.span({
  fontWeight: fontStyles.weights.semibold,
});

export const MiniLogo = styled.img({
  height: 56,
  float: 'right',
});
